import { FC, ReactNode } from 'react'
import { createGlobalStyle, ThemeProvider } from 'styled-components'
import './font-face.css'
import 'react-toastify/dist/ReactToastify.css'

import { breakpoints, media } from './breakpoints'
export { breakpoints, media }
const baseFontSize = 18

export const theme = {
    baseFontSize: baseFontSize,
    colors: {
        transparent: '#00000000',
        primaryGreen: '#399774',
        primaryGrey: '#F6F6F6',
        mediumGrey: '#464746',
        lightGrey: '#686A69',
        darkGrey: '#222523',
        lighterGrey: '#dddddd',
        primaryRed: '#C71800',
        lightRed: '#FFF3F3',
        primaryAmber: '#8A5300',
        lightAmber: '#FFF8E6',
        white: '#FFFFFF',
        black: {
            default: '#0A0B0A',
        },
        primary: {
            default: '#0A8447',
            green100: '#F5FAF9',
            green200: '#D4E9E0',
            green300: '#B3D9C8',
            green400: '#94C9B0',
            green500: '#76BA99',
            green600: '#55AA80',
            green700: '#359A68',
            green800: '#0DAA5B',
            green900: '#086938',
            green1000: '#064E24',
        },
        secondary: {
            default: '#880A47',
            secondary100: '#FCD9EA',
            secondary200: '#F9B4D5',
            secondary300: '#F78EC1',
            secondary400: '#F468AC',
            secondary500: '#F14397',
            secondary600: '#666666',
            secondary700: '#D3106E',
            secondary800: '#AE0D5B',
            secondary900: '#6C0838',
            secondary1000: '#50062A',
        },
        tertiary: {
            default: '#FAFAFA',
            tertiary50: '#F2F2F2',
            tertiary100: '#E3E3E3',
            tertiary200: '#CCCBCB',
            tertiary300: '#B5B3B3',
            tertiary400: '#9F9C9C',
            tertiary500: '#808080',
            tertiary600: '#666666',
            tertiary700: '#5A5555',
            tertiary800: '#404040',
            tertiary900: '#212121',
            tertiary1000: '#151413',
        },
        blue: {
            link: '#0071BC',
            blue100: '#EEF4FA',
            blue200: '#002E6E',
            blue300: '#0072DA',
            blue400: '#FAFCFF',
        },
    },
    fontWeight: {
        paragraph: 400,
        regular: 400,
        medium: 500,
        semiBold: 600,
        bold: 700,
    },
    breakpoints,
    media,
}

export const GlobalStyle = createGlobalStyle`
    *, *::before, *::after {
        box-sizing: border-box;
    }

    html, body, #root {
        width: 100%;
        height: 100%;
        margin: 0;
        font-size: ${baseFontSize}px;
        overflow-x: hidden;
    }

    body {
        overflow-wrap: break-word;
    }

    * {
        font-family: "Fira Sans", "sans-serif";
        font-weight: 400;
        font-style: normal;
    }
`

interface Props {
    children: ReactNode
}

export const Theme: FC<Props> = ({ children }) => {
    return (
        <>
            <GlobalStyle />
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </>
    )
}
